import { render } from "./BodySection.vue?vue&type=template&id=567a0629"
import script from "./BodySection.vue?vue&type=script&lang=js"
export * from "./BodySection.vue?vue&type=script&lang=js"

import "./BodySection.vue?vue&type=style&index=0&id=567a0629&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__